module.exports = __webpack_public_path__ + "img/sort-az-grey.1d651279.svg";